export const handles = [
  {
    name: "George Adam",
    handle: "@GeorgeAdam",
    email: "george.adam.msp@parliament.scot",
  },
  {
    name: "Karen Adam",
    handle: "none",
    email: "karen.adam.msp@parliament.scot",
  },
  {
    name: "Clare Adamson",
    handle: "@ClareAdamsonSNP",
    email: "clare.adamson.msp@parliament.scot",
  },
  {
    name: "Alasdair Allan",
    handle: "@alasdairallan",
    email: "alasdair.allan.msp@parliament.scot",
  },
  {
    name: "Tom Arthur",
    handle: "@ThomasCArthur",
    email: "tom.arthur.msp@parliament.scot",
  },
  {
    name: "Jackie Baillie",
    handle: "@jackiebmsp",
    email: "jackie.baillie.msp@parliament.scot",
  },
  {
    name: "Claire Baker",
    handle: "@clairebakermsp",
    email: "claire.baker.msp@parliament.scot",
  },
  {
    name: "Jeremy Balfour",
    handle: "@JeremyRBalfour",
    email: "jeremy.balfour.msp@parliament.scot",
  },
  {
    name: "Colin Beattie",
    handle: "@uartlach",
    email: "colin.beattie.msp@parliament.scot",
  },
  {
    name: "Neil Bibby",
    handle: "@NeilBibby",
    email: "neil.bibby.msp@parliament.scot",
  },
  {
    name: "Sarah Boyack",
    handle: "@SarahBoyack",
    email: "sarah.boyack.msp@parliament.scot",
  },
  {
    name: "Miles Briggs",
    handle: "@Miles4Lothian",
    email: "miles.briggs.msp@parliament.scot",
  },
  {
    name: "Keith Brown",
    handle: "@KeithBrownSNP",
    email: "keith.brown.msp@parliament.scot",
  },
  {
    name: "Siobhian Brown",
    handle: "@Siobhianayr",
    email: "siobhian.brown.msp@parliament.scot",
  },
  {
    name: "Ariane Burgess",
    handle: "@ArianeBurgessHI",
    email: "ariane.burgess.msp@parliament.scot",
  },
  {
    name: "Alexander Burnett",
    handle: "@AJABurnett",
    email: "alexander.burnett.msp@parliament.scot",
  },
  {
    name: "Stephanie Callaghan",
    handle: "@StephySNP",
    email: "stephanie.callaghan.msp@parliament.scot",
  },
  {
    name: "Donald Cameron",
    handle: "@DAJCameron",
    email: "donald.cameron.msp@parliament.scot",
  },
  {
    name: "Jackson Carlaw",
    handle: "@Jackson_Carlaw",
    email: "jackson.carlaw.msp@parliament.scot",
  },
  {
    name: "Finlay Carson",
    handle: "@fincarson",
    email: "finlay.carson.msp@parliament.scot",
  },
  {
    name: "Maggie Chapman",
    handle: "@MaggieChapman",
    email: "maggie.chapman.msp@parliament.scot",
  },
  {
    name: "Foysol Choudhury",
    handle: "@FoysolChoudhury",
    email: "foysol.choudhury.msp@parliament.scot",
  },
  {
    name: "Katy Clark",
    handle: "@KatySClark",
    email: "katy.clark.msp@parliament.scot",
  },
  {
    name: "Willie Coffey",
    handle: "@williecoffeysnp",
    email: "willie.coffey.msp@parliament.scot",
  },
  {
    name: "Alex Cole-Hamilton",
    handle: "@agcolehamilton",
    email: "alex.cole-hamilton.msp@parliament.scot",
  },
  {
    name: "Angela Constance",
    handle: "@AConstanceSNP",
    email: "angela.constance.msp@parliament.scot",
  },
  {
    name: "Ash Regan",
    handle: "@AshtenRegan",
    email: "ash.regan.msp@parliament.scot",
  },
  {
    name: "Graeme Dey",
    handle: "none",
    email: "graeme.dey.msp@parliament.scot",
  },
  {
    name: "Natalie Don",
    handle: "@NatalieDon_",
    email: "natalie.don.msp@parliament.scot",
  },
  {
    name: "Bob Doris",
    handle: "@BobDorisSNP",
    email: "bob.doris.msp@parliament.scot",
  },
  {
    name: "James Dornan",
    handle: "@glasgowcathcart",
    email: "james.dornan.msp@parliament.scot",
  },
  {
    name: "Sharon Dowey",
    handle: "@SharonDowey_",
    email: "sharon.dowey.msp@parliament.scot",
  },
  {
    name: "Jackie Dunbar",
    handle: "@JackieDunbarSNP",
    email: "jackie.dunbar.msp@parliament.scot",
  },
  {
    name: "Pam Duncan-Glancy",
    handle: "@GlasgowPam",
    email: "pam.duncan-glancy.msp@parliament.scot",
  },
  {
    name: "Annabelle Ewing",
    handle: "@aewing4Cbeath",
    email: "annabelle.ewing.msp@parliament.scot",
  },
  {
    name: "Fergus Ewing",
    handle: "@FergusEwingSNP",
    email: "fergus.ewing.msp@parliament.scot",
  },
  {
    name: "Jim Fairlie",
    handle: "@JimFairlieLogie",
    email: "jim.fairlie.msp@parliament.scot",
  },
  {
    name: "Russell Findlay",
    handle: "@RussellFindlay1",
    email: "russell.findlay.msp@parliament.scot",
  },
  {
    name: "Joe FitzPatrick",
    handle: "@JoeFitzSNP",
    email: "joe.fitzpatrick.msp@parliament.scot",
  },
  {
    name: "Kate Forbes",
    handle: "@_KateForbes",
    email: "kate.forbes.msp@parliament.scot",
  },
  {
    name: "Murdo Fraser",
    handle: "@murdo_fraser",
    email: "murdo.fraser.msp@parliament.scot",
  },
  {
    name: "Meghan Gallacher",
    handle: "@MGallacherMSP",
    email: "meghan.gallacher.msp@parliament.scot",
  },
  {
    name: "Kenneth Gibson",
    handle: "none",
    email: "kenneth.gibson.msp@parliament.scot",
  },
  {
    name: "Jenny Gilruth",
    handle: "@JennyGilruth",
    email: "jenny.gilruth.msp@parliament.scot",
  },
  {
    name: "Maurice Golden",
    handle: "@mgoldenmsp",
    email: "maurice.golden.msp@parliament.scot",
  },
  {
    name: "Pam Gosal",
    handle: "@PamGosalMSP",
    email: "pam.gosal.msp@parliament.scot",
  },
  {
    name: "Mairi Gougeon",
    handle: "@MairiGougeon",
    email: "mairi.gougeon.msp@parliament.scot",
  },
  {
    name: "Christine Grahame",
    handle: "@CGrahameMSP",
    email: "christine.grahame.msp@parliament.scot",
  },
  {
    name: "Rhoda Grant",
    handle: "@RhodaGrant",
    email: "rhoda.grant.msp@parliament.scot",
  },
  {
    name: "Neil Gray",
    handle: "@neilgraysnp",
    email: "neil.gray.msp@parliament.scot",
  },
  {
    name: "Jamie Greene",
    handle: "@jamiegreeneUK",
    email: "jamie.greene.msp@parliament.scot",
  },
  {
    name: "Ross Greer",
    handle: "@Ross_Greer",
    email: "ross.greer.msp@parliament.scot",
  },
  {
    name: "Mark Griffin",
    handle: "@MarkGriff1n",
    email: "mark.griffin.msp@parliament.scot",
  },
  {
    name: "Sandesh Gulhane",
    handle: "@Sandeshgulhane",
    email: "sandesh.gulhane.msp@parliament.scot",
  },
  {
    name: "Jamie Halcro Johnston",
    handle: "@jhalcrojohnston",
    email: "jamie.halcro.johnston.msp@parliament.scot",
  },
  {
    name: "Rachael Hamilton",
    handle: "@Rachael2Win",
    email: "rachael.hamilton.msp@parliament.scot",
  },
  {
    name: "Emma Harper",
    handle: "@EmmaHarperMSP",
    email: "emma.harper.msp@parliament.scot",
  },
  {
    name: "Patrick Harvie",
    handle: "@patrickharvie",
    email: "patrick.harvie.msp@parliament.scot",
  },
  {
    name: "Clare Haughey",
    handle: "@haughey_clare",
    email: "clare.haughey.msp@parliament.scot",
  },
  {
    name: "Jamie Hepburn",
    handle: "@jamiehepburn",
    email: "jamie.hepburn.msp@parliament.scot",
  },
  {
    name: "Craig Hoy",
    handle: "@CraigWHoy1",
    email: "craig.hoy.msp@parliament.scot",
  },
  {
    name: "Fiona Hyslop",
    handle: "@FionaHyslop",
    email: "fiona.hyslop.msp@parliament.scot",
  },
  {
    name: "Daniel Johnson",
    handle: "@djohnsonmsp",
    email: "daniel.johnson.msp@parliament.scot",
  },
  {
    name: "Alison Johnstone",
    handle: "@POScotParl",
    email: "alison.johnstone.msp@parliament.scot",
  },
  {
    name: "Liam Kerr",
    handle: "@LiamKerrMSP",
    email: "liam.kerr.msp@parliament.scot",
  },
  {
    name: "Stephen Kerr",
    handle: "@RealStephenKerr",
    email: "stephen.kerr.msp@parliament.scot",
  },
  {
    name: "Bill Kidd",
    handle: "@BillKiddSNP",
    email: "bill.kidd.msp@parliament.scot",
  },
  {
    name: "Monica Lennon",
    handle: "@MonicaLennon7",
    email: "monica.lennon.msp@parliament.scot",
  },
  {
    name: "Richard Leonard",
    handle: "@LabourRichard",
    email: "richard.leonard.msp@parliament.scot",
  },
  {
    name: "Richard Lochhead",
    handle: "@RichardLochhead",
    email: "richard.lochhead.msp@parliament.scot",
  },
  {
    name: "Douglas Lumsden",
    handle: "@dlumsden",
    email: "douglas.lumsden.msp@parliament.scot",
  },
  {
    name: "Gordon MacDonald",
    handle: "@GMacdonaldSNP",
    email: "gordon.macdonald.msp@parliament.scot",
  },
  {
    name: "Fulton MacGregor",
    handle: "@fultonsnp",
    email: "fulton.macgregor.msp@parliament.scot",
  },
  {
    name: "Gillian Mackay",
    handle: "@GillianMacMSP",
    email: "gillian.mackay.msp@parliament.scot",
  },
  {
    name: "Rona Mackay",
    handle: "@RonaMackaySNP",
    email: "rona.mackay.msp@parliament.scot",
  },
  {
    name: "Ben Macpherson",
    handle: "@BenMacpherson",
    email: "ben.macpherson.msp@parliament.scot",
  },
  {
    name: "Ruth Maguire",
    handle: "@RBFMaguire",
    email: "ruth.maguire.msp@parliament.scot",
  },
  {
    name: "Michael Marra",
    handle: "@michaeljmarra",
    email: "michael.marra.msp@parliament.scot",
  },
  {
    name: "Gillian Martin",
    handle: "@GillianMSP",
    email: "gillian.martin.msp@parliament.scot",
  },
  {
    name: "John Mason",
    handle: "@JohnMasonMSP",
    email: "john.mason.msp@parliament.scot",
  },
  {
    name: "Michael Matheson",
    handle: "@MathesonMichael",
    email: "michael.matheson.msp@parliament.scot",
  },
  {
    name: "Màiri McAllan",
    handle: "@MairiMcAllan",
    email: "màiri.mcallan.msp@parliament.scot",
  },
  {
    name: "Liam McArthur",
    handle: "@Liam4Orkney",
    email: "liam.mcarthur.msp@parliament.scot",
  },
  {
    name: "Roz McCall",
    handle: "@RozMccall",
    email: "roz.mccall.msp@parliament.scot",
  },
  {
    name: "Ivan McKee",
    handle: "@Ivan_McKee",
    email: "ivan.mckee.msp@parliament.scot",
  },
  {
    name: "Christina McKelvie",
    handle: "@ChristinaSNP",
    email: "christina.mckelvie.msp@parliament.scot",
  },
  {
    name: "Paul McLennan",
    handle: "@PaulMcLennan7",
    email: "paul.mclennan.msp@parliament.scot",
  },
  {
    name: "Stuart McMillan",
    handle: "@StuMcMillanSNP",
    email: "stuart.mcmillan.msp@parliament.scot",
  },
  {
    name: "Marie McNair",
    handle: "@MarieAMcNair",
    email: "marie.mcnair.msp@parliament.scot",
  },
  {
    name: "Pauline McNeill",
    handle: "@pauline4glasgow",
    email: "pauline.mcneill.msp@parliament.scot",
  },
  {
    name: "Jenni Minto",
    handle: "@jenni_minto",
    email: "jenni.minto.msp@parliament.scot",
  },
  {
    name: "Carol Mochan",
    handle: "@CMochan",
    email: "carol.mochan.msp@parliament.scot",
  },
  {
    name: "Sir Edward Mountain",
    handle: "@1edmountain",
    email: "sir.edward.mountain.msp@parliament.scot",
  },
  {
    name: "Oliver Mundell",
    handle: "@olivermundell",
    email: "oliver.mundell.msp@parliament.scot",
  },
  {
    name: "Audrey Nicoll",
    handle: "@Audrey4ASNK",
    email: "audrey.nicoll.msp@parliament.scot",
  },
  {
    name: "Paul O'Kane",
    handle: "@PFOKane",
    email: "paul.o'kane.msp@parliament.scot",
  },
  {
    name: "Willie Rennie",
    handle: "@willie_rennie",
    email: "willie.rennie.msp@parliament.scot",
  },
  {
    name: "Angus Robertson",
    handle: "@AngusRobertson",
    email: "angus.robertson.msp@parliament.scot",
  },
  {
    name: "Shona Robison",
    handle: "@ShonaRobison",
    email: "shona.robison.msp@parliament.scot",
  },
  {
    name: "Emma Roddick",
    handle: "@Emma_Roddick",
    email: "emma.roddick.msp@parliament.scot",
  },
  {
    name: "Douglas Ross",
    handle: "@Douglas4Moray",
    email: "douglas.ross.msp@parliament.scot",
  },
  {
    name: "Alex Rowley",
    handle: "@AlexRowleyFife",
    email: "alex.rowley.msp@parliament.scot",
  },
  {
    name: "Mark Ruskell",
    handle: "@markruskell",
    email: "mark.ruskell.msp@parliament.scot",
  },
  {
    name: "Anas Sarwar",
    handle: "@AnasSarwar",
    email: "anas.sarwar.msp@parliament.scot",
  },
  {
    name: "Graham Simpson",
    handle: "@GrahamSMSP",
    email: "graham.simpson.msp@parliament.scot",
  },
  {
    name: "Lorna Slater",
    handle: "@lornaslater",
    email: "lorna.slater.msp@parliament.scot",
  },
  {
    name: "Liz Smith",
    handle: "@mspliz",
    email: "liz.smith.msp@parliament.scot",
  },
  {
    name: "Colin Smyth",
    handle: "@colinsmythmsp",
    email: "colin.smyth.msp@parliament.scot",
  },
  {
    name: "Shirley-Anne Somerville",
    handle: "@S_A_Somerville",
    email: "shirley-anne.somerville.msp@parliament.scot",
  },
  {
    name: "Collette Stevenson",
    handle: "@CStevensonSNP",
    email: "collette.stevenson.msp@parliament.scot",
  },
  {
    name: "Alexander Stewart",
    handle: "none",
    email: "alexander.stewart.msp@parliament.scot",
  },
  {
    name: "Kaukab Stewart",
    handle: "@kaukabstewart",
    email: "kaukab.stewart.msp@parliament.scot",
  },
  {
    name: "Kevin Stewart",
    handle: "@KevinStewartSNP",
    email: "kevin.stewart.msp@parliament.scot",
  },
  {
    name: "Nicola Sturgeon",
    handle: "@NicolaSturgeon",
    email: "nicola.sturgeon.msp@parliament.scot",
  },
  {
    name: "Paul Sweeney",
    handle: "@PaulJSweeney",
    email: "paul.sweeney.msp@parliament.scot",
  },
  {
    name: "John Swinney",
    handle: "@JohnSwinney",
    email: "john.swinney.msp@parliament.scot",
  },
  {
    name: "Michelle Thomson",
    handle: "@MichelleThomson",
    email: "michelle.thomson.msp@parliament.scot",
  },
  {
    name: "Maree Todd",
    handle: "@MareeToddMSP",
    email: "maree.todd.msp@parliament.scot",
  },
  {
    name: "David Torrance",
    handle: "@DavidHTorrance",
    email: "david.torrance.msp@parliament.scot",
  },
  {
    name: "Evelyn Tweed",
    handle: "@EvelynTweedSNP",
    email: "evelyn.tweed.msp@parliament.scot",
  },
  {
    name: "Mercedes Villalba",
    handle: "@LabourMercedes",
    email: "mercedes.villalba.msp@parliament.scot",
  },
  {
    name: "Sue Webber",
    handle: "@SueJWebber",
    email: "sue.webber.msp@parliament.scot",
  },
  {
    name: "Annie Wells",
    handle: "@AnnieWellsMSP",
    email: "annie.wells.msp@parliament.scot",
  },
  {
    name: "Tess White",
    handle: "@TessWhite4NE",
    email: "tess.white.msp@parliament.scot",
  },
  {
    name: "Martin Whitfield",
    handle: "@_MWhitfield",
    email: "martin.whitfield.msp@parliament.scot",
  },
  {
    name: "Elena Whitham",
    handle: "@ElenaWhitham",
    email: "elena.whitham.msp@parliament.scot",
  },
  {
    name: "Brian Whittle",
    handle: "@BrianWhittle",
    email: "brian.whittle.msp@parliament.scot",
  },
  {
    name: "Beatrice Wishart",
    handle: "@BeatriceWishart",
    email: "beatrice.wishart.msp@parliament.scot",
  },
  {
    name: "Humza Yousaf",
    handle: "@HumzaYousaf",
    email: "humza.yousaf.msp@parliament.scot",
  },
];